angular.module('gym.contacts').factory('NacConvertToProspectService', ["$http", "$modal", "$state", "flash", "loadingAnimation", function($http, $modal, $state, flash, loadingAnimation) {
  return {
    convert: function(contact, gym) {
      var modalInstance;
      modalInstance = $modal.open({
        template: require('templates/gyms/contacts/nacConfirmConvertToProspectModal.html.slim'),
        resolve: {
          contact: function() {
            return contact;
          }
        },
        controller: ["$scope", "$modalInstance", "contact", function($scope, $modalInstance, contact) {
          $scope.contact = contact;
          $scope.submit = function() {
            return $modalInstance.close();
          };
          return $scope.cancel = function() {
            return $modalInstance.dismiss('cancel');
          };
        }]
      });
      return modalInstance.result.then(function() {
        loadingAnimation.show();
        return $http.put('/convert_nac_to_prospect', {
          id: contact.id,
          gym_id: gym.id()
        }).then(function() {
          flash.success = `${contact.name} converted to prospect`;
          loadingAnimation.hide();
          return $state.go('gym.contacts.edit', {
            contactType: 'prospects',
            contactId: contact.id
          });
        }, function(response) {
          loadingAnimation.hide();
          return flash.error = response.data.error;
        });
      });
    }
  };
}]);
